/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionFromJSON, FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOption';
import { FxIdDomainSettingsUnityOptionsDistributionOptionsComponentFromJSON, FxIdDomainSettingsUnityOptionsDistributionOptionsComponentToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionOptionsComponent';
import { FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSON, FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts';
/**
 * Check if a given object implements the FxIdDomainSettingsUnityOptionsDistributionOptions interface.
 */
export function instanceOfFxIdDomainSettingsUnityOptionsDistributionOptions(value) {
    if (!('ForceCompressionOption' in value) || value['ForceCompressionOption'] === undefined)
        return false;
    if (!('LoaderFileName' in value) || value['LoaderFileName'] === undefined)
        return false;
    if (!('DataFileName' in value) || value['DataFileName'] === undefined)
        return false;
    if (!('CodeFileName' in value) || value['CodeFileName'] === undefined)
        return false;
    if (!('FrameworkFileName' in value) || value['FrameworkFileName'] === undefined)
        return false;
    if (!('WebGlContextOpts' in value) || value['WebGlContextOpts'] === undefined)
        return false;
    if (!('RequestPointerLocking' in value) || value['RequestPointerLocking'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ForceCompressionOption': FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionFromJSON(json['ForceCompressionOption']),
        'LoaderFileName': json['LoaderFileName'],
        'DataFileName': json['DataFileName'],
        'CodeFileName': json['CodeFileName'],
        'MobileDataFileName': json['MobileDataFileName'] == null ? undefined : json['MobileDataFileName'],
        'FrameworkFileName': json['FrameworkFileName'],
        'SymbolsFileName': json['SymbolsFileName'] == null ? undefined : json['SymbolsFileName'],
        'MemoryFileName': json['MemoryFileName'] == null ? undefined : json['MemoryFileName'],
        'StreamingAssetsUrl': json['StreamingAssetsUrl'] == null ? undefined : json['StreamingAssetsUrl'],
        'StreamingAssetsMobileUrl': json['StreamingAssetsMobileUrl'] == null ? undefined : json['StreamingAssetsMobileUrl'],
        'WebGlContextOpts': FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSON(json['WebGlContextOpts']),
        'RequestPointerLocking': json['RequestPointerLocking'],
        'Component': json['Component'] == null ? undefined : FxIdDomainSettingsUnityOptionsDistributionOptionsComponentFromJSON(json['Component']),
    };
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ForceCompressionOption': FxIdDomainSettingsUnityOptionsDistributionOptionsForceCompressionOptionToJSON(value['ForceCompressionOption']),
        'LoaderFileName': value['LoaderFileName'],
        'DataFileName': value['DataFileName'],
        'CodeFileName': value['CodeFileName'],
        'MobileDataFileName': value['MobileDataFileName'],
        'FrameworkFileName': value['FrameworkFileName'],
        'SymbolsFileName': value['SymbolsFileName'],
        'MemoryFileName': value['MemoryFileName'],
        'StreamingAssetsUrl': value['StreamingAssetsUrl'],
        'StreamingAssetsMobileUrl': value['StreamingAssetsMobileUrl'],
        'WebGlContextOpts': FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSON(value['WebGlContextOpts']),
        'RequestPointerLocking': value['RequestPointerLocking'],
        'Component': FxIdDomainSettingsUnityOptionsDistributionOptionsComponentToJSON(value['Component']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionOptions.js.map